import borders from 'assets/theme/base/borders';
import rgba from 'assets/theme/function/rgba';
import colors from 'assets/theme/base/colors';
import boxShadow from 'assets/theme/function/box-shadow';
import pxToRem from 'assets/theme/function/px-to-rem';
import { breakpoints } from 'assets/theme/base/breakpoints';

const { borderRadius } = borders;

const dialog = {
    styleOverrides: {
        root: {
            '& .MuiBackdrop-root': {
                backgroundColor: rgba(colors.secondary.light, 0.8),
            },
        },
        paper: {
            flex: 1,
            maxWidth: pxToRem(900),
            maxHeight: 'calc(100% - 10px)',
            backgroundColor: colors.secondary.main,
            borderRadius: borderRadius.fiveXl,
            b0oxShadow: boxShadow([0, 8], [8, 0], colors.common.black, 0.25),

            [breakpoints.down('md')]: {
                margin: pxToRem(10),
            },
        },
    },
};

export default dialog;
